/**
 * Cloudflare Turnstile site key for the contact forms (public value).
 * Widget "log.pt contact forms" allows log.pt, www.log.pt and site-log.pages.dev.
 * In development we use Cloudflare's always-pass test key so localhost works.
 */
export const TURNSTILE_SITE_KEY =
  process.env.NODE_ENV === 'development'
    ? '1x00000000000000000000AA'
    : '0x4AAAAAAFYYxWTlOAGu50ck'

export const TURNSTILE_SCRIPT_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
